/// <reference types="google.accounts" />
import { config } from '@iheartjane/config';
import { useRuntimeConfig } from '@iheartjane/runtime-config';

import { useScript } from './useScript';

export const GOOGLE_SDK_SRC = 'https://accounts.google.com/gsi/client';

type GoogleCodeResponse = google.accounts.oauth2.CodeResponse;

const isGoogleSDKReady = () =>
  Boolean(typeof window !== 'undefined' && window.google?.accounts?.oauth2);

export const useGoogleSDK = () => {
  const { embedConfigId, ssoCredentials } = useRuntimeConfig();
  const isLoaded = useScript(GOOGLE_SDK_SRC, { isReady: isGoogleSDKReady });

  const signIn = (onCode: (response: GoogleCodeResponse) => void) => {
    if (!isGoogleSDKReady()) return;

    window.google.accounts.oauth2
      .initCodeClient({
        client_id: ssoCredentials['google_oauth2'] || config.googleClientId,
        scope: 'profile email',
        state: embedConfigId ? `embedConfigId+${embedConfigId}` : undefined,
        callback: onCode,
      })
      .requestCode();
  };

  return { isLoaded, signIn };
};
